// @ts-nocheck

import {Project, ProjectAnalysis} from "../../modules/projects/models/Project";
import {Button,  Table, TableCell, TableContainer, TableRow} from "@material-ui/core";
import ArrowBack from "@material-ui/icons/ArrowBack";
import {commonStyles} from "../../common/styles/Styles";
import {useTranslation} from "react-i18next";
import { useState, useEffect } from 'react';

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import styles from './FourthStep.module.css'
import { getTestContainer } from "container/test-module";
import { TestService } from "modules/tests/services/TestService";
import { TEST_SERVICE_KEY } from "modules/tests";
import { Embryo, EmbryoGender, FinalStatusIndividual, Report, Status } from "../../modules/tests/models/Reports"
import { RolePGDTest } from "modules/users/enums/RoleType";
import { InformativeSNP } from "./Form";
import {ProjectService} from 'modules/projects/services/ProjectService'
import {PROJECT_SERVICE_KEY} from 'modules/projects'
import {getProjectContainer} from 'container/project-module'
import { getFileContainer } from "container/file-module";
import { FileService } from "modules/files/services/FileService";
import { FILE_SERVICE_KEY } from "modules/files";
import { File } from "modules/files/models/File";
import { Field } from "components/table";
import { Body } from "components/table/Body";
import { Head } from "components/table/Head";
import { directTestingStatusTitle, FinalStatus, Status as IndividualStatus, statusTitle } from "modules/individuals/enums/Status";
import { Query, QueryParam } from "common/api/Query";
import { Individual } from "modules/individuals/models/Individual";
import { Individuals } from "modules/individuals/enums/Individuals";
import { MutationsPosition } from "modules/mutationsPosition/models/MutationsPosition";
import { getEmbryoContainer } from "container/embryo-module";
import { EmbryoService } from "modules/embryos/services/EmbryoService";
import { EMBRYO_SERVICE_KEY } from "modules/embryos";
import { Embryo as EmbryoModel } from "modules/embryos/models/Embryo";
import { getDirectTestingContainer } from "container/directTesting-module";
import { DirectTestingService } from "modules/directTesting/services/DirectTestingService";
import { DIRECT_TESTING_SERVICE_KEY } from "modules/directTesting";
import { DirectTesting } from "modules/directTesting/models/DirectTesting";

const testService = getTestContainer().get<TestService>(TEST_SERVICE_KEY)
const projectService = getProjectContainer().get<ProjectService>(PROJECT_SERVICE_KEY)
const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)
const embryoService = getEmbryoContainer().get<EmbryoService>(EMBRYO_SERVICE_KEY)
const directTestingService = getDirectTestingContainer().get<DirectTestingService>(DIRECT_TESTING_SERVICE_KEY)


type SecondStepProps = {
     increaseStep?: () => void
        deleteFiles?: () => void
        setCurrentStep: (i: number) => void
        project?: ProjectAnalysis
        headerID: string | ''
        signatureID: string | ''
        seeSex: boolean
        patientInfo?: InformativeSNP
        partnerInfo?: InformativeSNP
        roleSigne?: string | ''
        signedBy?: string | ''
        setFromIndi: (b: boolean)=>void
        setFromEmb: (b: boolean)=>void
        fromIndi: boolean
        fromEmb: boolean
}

export const FourthStep = (props: SecondStepProps) => {


    const [data, setData] = useState<Report>();
    const [project, setProject] = useState<Project>()
    const isGene = data?.Panel.genRegion === "Gene"
    const styles2 = commonStyles()
    const {t} = useTranslation()
    const [header, setHeader] = useState<File>()
    const [signature, setSignature] = useState<File>()
    const [technicalSheet, setTechnicalSheet] = useState<boolean>()
    const [individuals, setIndividuals] = useState<Individual[]>([])
    const [maternalVar, setMaternalVar] = useState<MutationsPosition[]>([])
    const [paternalVar,setPaternalVar] = useState<MutationsPosition[]>([])
    const [embryo, setEmbryo] = useState<EmbryoModel[]>([])
    const [samevariant, setSameVariant] = useState<MutationsPosition>()
    const [directTesting, setDirecTesting] = useState<DirectTesting[]>([])


    const confidenceColor = (level: number): string => {
        switch (level) {
            case 0: return '#ee5252'
            case 1: return '#e86f4a'
            case 2: return '#e39e43'
            case 3: return '#ddb73a'
            case 4: return '#ebee52'
            case 5: return '#c8d64f'
            case 6: return '#a3bf4b'
            case 7: return '#7fb946'
            case 8: return '#57ee52'
            default: return '#000000'
        }
    };

    const validDirectDetection = (variantsList) => {
        var isDisable: boolean = true
        if (variantsList.length === 0) isDisable = false
        variantsList.forEach(variant => {
            if (variant.type === "SNP") isDisable = false
            else if ((variant.end-variant.start)<15) isDisable = false
        })

        return !isDisable
        
    }

    const fields: Field<any>[] = [
            {
                sortable: false,
                searchable: false,
                label: t('individual'),
                name: 'individual',
            },
            {
                sortable: false,
                searchable: false,
                label: t('status'),
                name: 'status',
            },
            {
                sortable: false,
                searchable: false,
                label: t('mutation'),
                name: 'mutation',
            },
            {
                sortable: false,
                searchable: false,
                label:'NOCALL %',
                name: 'NOCALL %',
            },
             ...((maternalVar?.length + paternalVar?.length) > 0 
                ?[ ...maternalVar.map(mv => ({
                    sortable: false,
                    searchable: false,
                    label:  mv.description  ,
                    name: 'directVariant',
                })),
                ...paternalVar
                    .filter(pv => pv.description !== samevariant?.description)
                    .map(pv => ({
                        sortable: false,
                        searchable: false,
                        label:pv.description,
                        name: 'directVariant',
                    })),] : []),
        ]

        const fields2: Field<any>[] = [
            {
                sortable: false,
                searchable: false,
                label: "",
                name: 'name',
            },
            {
                sortable: false,
                searchable: false,
                label: "NONCALL %",
                name: 'NONCALL %',
            },
            ...(validDirectDetection(maternalVar)
                ? maternalVar.map(mv => ({
                    sortable: false,
                    searchable: false,
                    label: mv.description,
                    name: 'directVariant',
                    }))
                : []
            ),
            ...(validDirectDetection(paternalVar) ?
                paternalVar
                .filter(pv => pv.description !== samevariant?.description)
                .map(pv => ({
                    sortable: false,
                    searchable: false,
                    label: pv.description,
                    name: 'directVariant',
                })) : []
            ) ,
            
            ...(maternalVar.length > 0 ?
                [{
                sortable: false,
                searchable: false,
                label: t('maternalInherit'),
                name: 'maternalInherit',
                }] : []

            ),
            ...(paternalVar.length > 0 ?
                [{
                    sortable: false,
                    searchable: false,
                    label: t('paternalInherit'),
                    name: 'paternalInherit',
                }] : []
            ),
            ...(props.seeSex? [{
                sortable: false,
                searchable: false,
                label: t('gender'),
                name: 'gender',
            }] : []),
            {
                sortable: false,
                searchable: false,
                label:t('sugestStatus'),
                name: 'sugestStatus',
            },
        ]
    useEffect(() => {
     testService.report(
        props.project?.id || ""
     ).subscribe((res) => {
            setData(res)
            data?.Embryos !== undefined ? setTechnicalSheet(props.project?.embryoValidateBy != "") : setTechnicalSheet(props.project?.infoValidateBy != "")
        });
        projectService.getByID(props.project?.id || "").subscribe((res)=>{
          res!= undefined && setProject(res)
        })


       if (props.headerID && props.headerID !== '' ) fileService.getHeaderByID(props.headerID).subscribe(res => {
        setHeader(res)
        })   

        if (props.headerID && props.headerID !== '' ) fileService.getSignatureByID(props.signatureID).subscribe(res => {
            setSignature(res)
    })

            embryoService.getFilteredList(
                new Query({
                    query: [new QueryParam('embryosGroupID', props.project?.embryosGroupID || '')]
                })
            ).subscribe(res =>{
                if (res ) {
                    setEmbryo(res.items)}
            } )


    }, [props.project?.id]);


useEffect(()=>{
  const requests: Observable<ApiResponse<DirectTesting[]>>[] = [];

  if (maternalVar?.length > 0) {
    maternalVar.forEach(mv => {
      requests.push(directTestingService.getByMutationID(mv.id));
    });
  }

  if (paternalVar?.length > 0) {
    paternalVar.forEach(pv => {
      const isDuplicate = maternalVar?.some(mv => mv.description === pv.description);
      if (!isDuplicate) {
        requests.push(directTestingService.getByMutationID(pv.id));
      } else {
        setSameVariant(pv); 
      }
    });
  }

  if (requests.length === 0) {
    setDirecTesting([]);
    return;
  }

  forkJoin(requests)
    .subscribe({
      next: (responses) => {
        const directTestList: DirectTesting[] = [];

        responses.forEach(res => {
          if (res && res.items) {
            res.items.forEach(item => {
              const existsIndex = directTestList.findIndex(
                dt => dt.individualID === item.individualID && dt.mutationID === item.mutationID
              );

              if (existsIndex >= 0) {
                if (item.status === IndividualStatus.Carrier) {
                  directTestList[existsIndex] = item;
                }
              } else {
                directTestList.push(item);
              }
            });
          }
        });

        setDirecTesting(directTestList); 
      },
      error: (err) => {
        console.error('Error cargando direct testing:', err);
        setDirecTesting([]); 
      }
    });
    },[paternalVar, maternalVar])

useEffect(() => {
            
        let auxMaternalVar: MutationsPosition[]=[]
        let auxPaternalVar: MutationsPosition[]=[]

        // debugger

        mutationService.getByProjectID(props.project?.mutationPositionsID || '').subscribe(resV => {
        
            if (resV){
                resV.items.map(variant => {
                    if (variant.paternal === 'mother') auxMaternalVar.push(variant)
                    if(variant.paternal === 'father') auxPaternalVar.push(variant)
        
                })
                setMaternalVar(auxMaternalVar)
                setPaternalVar(auxPaternalVar)
            }

        }
        )
    },[props.project])
    
    const formatDate = (dateS: Date | undefined) => {
        if (dateS === undefined ) return "No data"
        const date = new Date(dateS)

        const day = String(date.getDate()).padStart(2, '0');  
        const month = String(date.getMonth() + 1).padStart(2, '0'); 
        const year = date.getFullYear(); 
        
        return `${day}/${month}/${year}`;
    }
      const colorP = (dataInd: any, fStatus: FinalStatusIndividual | undefined, column: number) => {
               switch (props.project?.pathology){
                   case "X-Linked":
                       if (fStatus === FinalStatusIndividual.AffectedFinal){
                           if  (dataInd.RolePGDTest === RolePGDTest.MaleMother ||
                               dataInd.RolePGDTest === RolePGDTest.FemaleMother ||
                               dataInd.RolePGDTest === RolePGDTest.Female ||
                               (dataInd.RolePGDTest === RolePGDTest.Child && props.project?.childGender === 2) 
                           ) {
                                       return "#ff7b54"; // Rojo claro (Afectado) 
                               } else if (column === 1) {
                                   return "#ff7b54";
                               } else return "#96f68a";
                       } else if (fStatus === FinalStatusIndividual.CarrierFromFather){
                           return column === 1 ?  "#96f68a" :  "#ff7b54";
                       }  else if (fStatus === FinalStatusIndividual.CarrierFromMother){
                           return column === 2 ?  "#96f68a" :  "#ff7b54";
                       } else return "#96f68a";
       
       
                     default:
                        const child = data?.Status?.find(i => i.RolePGDTest === RolePGDTest.Child)
                        if (fStatus === FinalStatus.Affected)return "#ff7b54"; // Rojo claro (Afectado) 
                        else if (fStatus === FinalStatus.CarrierFromFather){
                            if(child && (child.StatusIndividual === FinalStatus.NonCarrier || child.StatusIndividual === FinalStatus.Null) &&
                            (dataInd.RolePGDTest === RolePGDTest.Male || data.role === RolePGDTest.Female)){
                                return column === 1 ?  "#96f68a" :  "#ff7b54";
                        }
                            return column === 1 ?  "#96f68a" :  "#ff7b54";
                        }  else if (fStatus === FinalStatus.CarrierFromMother){
                            if(child && (child.StatusIndividual === FinalStatus.NonCarrier || child.StatusIndividual === FinalStatus.Null) &&
                            (dataInd.RolePGDTest === RolePGDTest.Male || data.role === RolePGDTest.Female) ){
                                return column === 1 ?  "#96f68a" :  "#ff7b54";
                        }
                            return column === 2 ?  "#96f68a" :  "#ff7b54";
                        } else return "#96f68a";
                
                        }
                
                    
                    };

        
      const colorPEmbryo = (embryo: Embryo | undefined, indx: number) => {
        var color: string
        if (indx === 1) {
            color = embryo?.ColorA1 != null ?  embryo?.ColorA1.slice(1, -1)  : ''
            if (color.length > 7)  return "#F2EE81" 
        } else  {
            color = embryo?.ColorA2 != null ?  embryo?.ColorA2.slice(1, -1)  : ''
            if (color.length > 7)  return "#F2EE81" 
        }

        switch (props.project?.pathology){
            case "X-Linked":
                if (embryo?.FinalStatus === FinalStatusIndividual.AffectedFinal){
                    if(embryo.Sex !== EmbryoGender.Male)
                    {return "#ff7b54"; // Rojo claro (Afectado) 
                        } else if (indx === 1) {
                            return "#ff7b54";
                        } else return "#96f68a";
                } else if (embryo?.FinalStatus === FinalStatusIndividual.CarrierFromFather){
                    return indx === 1 ?  "#96f68a" :  "#ff7b54";
                }  else if (embryo?.FinalStatus === FinalStatusIndividual.CarrierFromMother){
                    return indx === 2 ?  "#96f68a" :  "#ff7b54";
                } else return "#96f68a";

                default:
                    if (embryo?.FinalStatus === FinalStatusIndividual.AffectedFinal)return "#ff7b54"; // Rojo claro (Afectado) 
                    else if (embryo?.FinalStatus === FinalStatusIndividual.CarrierFromFather){
                        return indx === 1 ?  "#96f68a" :  "#ff7b54";
                    }  else if (embryo?.FinalStatus === FinalStatusIndividual.CarrierFromMother){
                        return indx === 2 ?  "#96f68a" :  "#ff7b54";
                    } else return "#96f68a";
      }
    }


      const isLR = (embryo: Embryo | undefined, indx: number) => {
        var color: string
        if (indx === 1) {
            color = embryo?.ColorA1 != null ?  embryo?.ColorA1.slice(1, -1)  : ''
            if (color.length > 7)  return "LR" 
            else return 'P1'
        } else  {
            color = embryo?.ColorA2 != null ?  embryo?.ColorA2.slice(1, -1)  : ''
            if (color.length > 7)  return "LR" 
            else return 'P2'
        }
      }


      


     const isFamiliDirect = (rol: RolePGDTest | undefined) => {
        if (rol === 1 || rol === 2 || rol === 3 ) return true
        else return false
     }
    

     const roleIndividual = (status: RolePGDTest | undefined) => {
        switch (status) {
            case 0: 
                return "Female\nFather"
            case 1: 
                return " \nFemale"
            case 2: 
                return " \nMale"
            case 3: 
                return " \nChild"
            case 4: 
                return "Female\nMother"
            case 5: 
                return "Male\nMother"
            case 6: 
                return "Male\nFather"
            case 9:
                return "Female\nBrother"

        }
     }

     const StatusIndividuals = (individualState: FinalStatusIndividual | undefined, role?: RolePGDTest) => {
        const isMaleRole = role === RolePGDTest.FemaleFather || role === RolePGDTest.Male || role === RolePGDTest.MaleFather ||
            (role === RolePGDTest.Child && props.project?.childGender === 1)
        const isXLinked = props.project?.pathology === "X-Linked"
        switch (individualState) {
            case 0: 
                return 'Non Carrier' 
            case 3: 
                return "Affected"
            case 4: 
                return 'Null' 
            default:
                if (isXLinked && isMaleRole) return "Affected"
                return 'Carrier'
        }
     }
      
      
     const statusEmbryo = (embryos: FinalStatusIndividual | undefined, sexo: EmbryoGender, item: EmbryoModel) => {
        if (item.inconclusive) return t('inconclusive')

        if (item.a1ColumnName !== 'P1' || item.a2ColumnName !== 'P2') {
                 if (item.a1ColumnName === 'LR' || item.a2ColumnName === 'LR') {
                         return "Likely Recombinant"
                       } 
            
                        if (item.finalStatus === FinalStatus.Affected) {
                            if ((item.a1ColumnName === 'LRCM') || (item.a2ColumnName === 'LRCF')) return "Likely Recombinant, but seems to be Affected"
                            if (item.a1ColumnName === 'LRNC') return "Likely Recombinant, but seems to be Carrier from Father"
                            if (item.a2ColumnName === 'LRNC') return "Likely Recombinant, but seems to be Carrier from Mother"
                        } else {
                             if (item.finalStatus === FinalStatus.CarrierFromFather && item.a1ColumnName === 'LRCM')  return "Likely Recombinant, but seems to be Carrier from Father" 
                             if (item.finalStatus === FinalStatus.CarrierFromMother && item.a2ColumnName === 'LRCF')  return "Likely Recombinant, but seems to be Carrier from Mother" 
                             
                               if (item?.a1ColumnName !== 'P1') {
                                    return item?.a1ColumnName === 'LRNC'
                                        ? 'Recombinant but seems to be Non-Carrier'
                                        : item?.a1ColumnName === 'LRCM' 
                                        ? "Recombinant but seems to be Carrier from mother"
                                        : "Likely Recombinant" 
                                }
                            if (item?.a2ColumnName !== 'P2') {
                                return item?.a2ColumnName === 'LRNC'
                                    ? 'Recombinant but seems to be Non-Carrier'
                                    : item?.a2ColumnName === 'LRCF' 
                                    ? "Recombinant but seems to be Carrier from mother"
                                    : "Likely Recombinant"
                            }
                            return 'Likely Recombinant'
                        } 
        }     
        
        if (props.project?.pathology === "Dominant") {
            switch (embryos) {
                case 0: 
                    return 'Non Carrier' 
                case 4: 
                    return 'Null' 
                default:
                    return 'Affected'
            }
        }  else {
            if (props.project?.pathology === "X-Linked" && embryos === 1 && String(sexo) === "male") {
      

                return "Affected"
            } else{
                switch (embryos) {
                    case 0: 
                    return 'Non Carrier' 
                    case 1: 
                    return "Carrier From Mother"
                    case 2: 
                    return "Carrier From Father"
                    case 3: 
                    return "Affected"
                    case 4: 
                    return 'Null' 
                }}
            }
       
     }


     const halfColor1 = (colorS: string, position: number) => {
        if (colorS === "" ) return '#ddeafb' 
        colorS = colorS?.slice(1, -1);

        if(colorS?.length === 7) {
            return colorS
        } else {
            const color = colorS?.split(",")

            return color[position]
        }
     }


     const cutName = (nombre: string= "") => {
        return nombre
                .replace(/-/g, "- ")
                .replace(/_/g, " ")    
     }
     
          const inheritanceType = (acronym: string = ""): string => {
            switch (acronym){
                case "AR":
                    return "AR - Autosomical Recessive"
                case "AD": 
                    return "AD - Autosomical Dominant"
                case "":
                    return ""
                default:
                    return "XLR - X-Linked"
            }
          }
     
          const reorderIndividuals = (individuals: Status[] = []) => {
              var aux: RolePGDTest[] = [4,0,5,6,1,2,3]
              
              var reorder: Status[] = individuals.sort((a, b) => {
                 return aux.indexOf(a.RolePGDTest) - aux.indexOf(b.RolePGDTest);
              })
     
     
                return reorder
          }

    const generateHeader = () => {
        return (<header>
                <img src={`data:${header?.mimeType};base64,${header?.data}`} alt=""  style={{width: '100%', height: '234px'}} />

        <div style={{marginBottom: 10}}>
            <table className={styles.dataTable}>
                <tr >
                    <td className={styles.name}><b>Name:</b></td>
                    <td className={styles.name}>{data?.Name}</td>
                    <td className={styles.name}><b>Name:</b></td>
                    <td className={styles.name}>{data?.NamePartner}</td>
                </tr>
                <tr>
                    <td className={styles.dataTabletd}><b>Birth date:</b></td>
                    <td className={styles.dataTabletd}>{formatDate(data?.Birthdate)}</td>
                    <td className={styles.dataTabletd}><b>Birth date:</b></td>
                    <td className={styles.dataTabletd}>{formatDate(data?.BirthdatePartner)}</td>
                </tr>
                <tr>
                    <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                    <td className={styles.dataTabletd} >{data?.PatientId}</td>
                    <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                    <td className={styles.dataTabletd} >{data?.PatientIdPartner}</td>
                </tr>
                <tr>
                    <td className={styles.dataTabletd}><b>Sex:</b></td>
                    <td className={styles.dataTabletd} >{Number(data?.Gender) === 1 ? "male" : "female"}</td>
                    <td className={styles.dataTabletd}><b>Sex:</b></td>
                    <td className={styles.dataTabletd} >{Number(data?.GenderPartner) === 1 ? "male" : "female"}</td>
                </tr>
                <tr>
                    <td className={styles.dataTabletd}><b>Sample type:</b></td>
                    <td className={styles.dataTabletd} >{data?.SampleType}</td>
                    <td className={styles.dataTabletd}><b>Sample type:</b></td>
                    <td className={styles.dataTabletd} >{data?.SampleTypePartner}</td>
                </tr>
                <tr>
                    <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                    <td className={styles.datatdLast} >{formatDate(data?.SampleDate)}</td>
                    <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                    <td className={styles.datatdLast} >{formatDate(data?.SampleDatePartner)}</td>
                </tr>
                <tr>
                    <td className={styles.reportDate} colSpan={4}><b>Report date:</b> {formatDate(data?.ReportDate)}</td>
                </tr> 
    
            </table>
        </div>
    </header>)

    } 

    
    const generatePDF = () =>{
        
        return (
        <div style={{textAlign: 'left'}}>
        <div style={{width: '100%', fontSize: '1.6em', padding: '0 50px 0 50px '}}  id="pdf-content">
        {/* <div style={{width: '100%', fontSize: '1.6em', padding: '0 50px 0 50px' , position: 'absolute', left: '-9999px'}}  id="pdf-content"> */}
         
                <header>
                    <img src={`data:${header?.mimeType};base64,${header?.data}`} alt=""  style={{width: '100%', height: '234px'}} />
                    
                    <div style={{marginBottom: 10}}>
                        <table className={styles.dataTable}>
                            <tr >
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.Name}</td>
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.NamePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.Birthdate)}</td>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.BirthdatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientId}</td>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientIdPartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.Gender) === 1 ? "male" : "female"}</td>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.GenderPartner) === 1 ? "male" : "female"}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleType}</td>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleTypePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDate)}</td>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.reportDate} colSpan={4}><b>Report date:</b> {formatDate(data?.ReportDate)}</td>
                            </tr> 
                
                        </table>
                    </div>
                </header>
                <h1 className={styles.titleP} style={{textAlign: 'center'}}>Informativity Study for <i>{data?.KeySnp}</i></h1>
                <h2 className={styles.titleP} style={{textAlign: 'center'}}><i>{data?.Region}</i></h2>
                <div className="">
                    <div className="">
                        <h2 className={styles.titleP}>Indication</h2>
                        <p>The Informative Study is a crucial preliminary step before performing Preimplantation Genetic Testing for Monogenic disorders 
                        (PGT-M), to select embryos that are not affected by a specific genetic disease. The process includes a linkage analysis, examining
                        hundreds of polymorphisms around the region of interest to identify the risk haplotype. Additionally, whenever possible, a direct 
                        analysis is conducted to detect the disease-causing mutation. To achieve accurate results, this type of study generally requires the 
                        participation of one or more family members of the couple.</p>
                    </div>
                    <div className="">
                        <h2 className={styles.titleP}>Results</h2>
                        <p>After the analysis of {data?.TotalSNP} polymorphisms, {data?.TotalAnalyzedSNPINFO + " "}
                        informative polymorphisms were detected which will allow to analyze the embryos successfully (Table 1).</p>
                    </div>
                </div>
                <div >
                    <div className={styles.titleP}>Table 1. Results obtained from informativity study with PG-SEQ kit.</div>
                    <table className={styles.patientTable}>
                        <tr>
                            <th colSpan={6} className={styles.titleTable} >Results from informativity study</th>
                        </tr>
                        <tr style={{textAlign: 'left'}}>
                            <th>Region</th>
                            { isGene && <td colSpan={5}><i>{data?.KeySnp}</i></td>}
                        </tr>
                        <tr style={{textAlign: 'left'}}>
                            <th>Chromosome</th>
                            <td colSpan={5}>{data?.Panel.chr} {isGene && `(${data?.Panel.transcrit} as canonical transcript)`}</td>
                        </tr>
                        <tr style={{textAlign: 'left'}}>
                            <th>Chromosomic region</th>
                            <td colSpan={5}>{props.project?.firstSNP} – {props.project?.lastSNP} (Human GRCh38) </td>
                        </tr>
                        <tr style={{textAlign: 'left'}}>
                            <th>Inheritance pattern</th>
                            <td colSpan={5}>{inheritanceType(data?.Panel.herencyPatern)}</td>
                        </tr>
                        <tr>
                            <th rowSpan={2}>Members of the study</th>
                            <th rowSpan={2}>CALL RATE</th>
                            <th colSpan={3}>Number of informative SNPs</th>
                        </tr>
                        <tr>
                            <th>Upstream region</th>
                            <th>Intragenic region</th>
                            <th>Downstream region</th>
                        </tr>
                        <tr>
                            <td>{data?.Name}</td>
                            <td>{data?.ValidSNP} / {data?.TotalSNP}</td>
                            <td>{project?.femaleUpstream} </td>
                            <td>{project?.femaleIntrangenic} </td>
                            <td>{project?.femaleDownstream} </td>
                        </tr>
                        <tr>
                            <td>{data?.NamePartner}</td>
                            <td>{data?.ValidSNPPartner} / {data?.TotalSNPPartner }</td>
                            <td>{project?.maleUpstream} </td>
                            <td>{project?.maleIntrangenic} </td>
                            <td>{project?.maleDownstream} </td>
                        </tr>
                    </table>
                </div>
                <br /><br /><br /><br /> <br /><br /><br /><br /> <br /><br />
                <header>
                <img src={`data:${header?.mimeType};base64,${header?.data}`} alt=""  style={{width: '100%', height: '234px'}} />

                    <div style={{marginBottom: 10}}>
                        <table className={styles.dataTable}>
                            <tr >
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.Name}</td>
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.NamePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.Birthdate)}</td>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.BirthdatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientId}</td>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientIdPartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.Gender) === 1 ? "male" : "female"}</td>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.GenderPartner) === 1 ? "male" : "female"}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleType}</td>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleTypePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDate)}</td>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.reportDate} colSpan={4}><b>Report date:</b> {formatDate(data?.ReportDate)}</td>
                            </tr> 
                
                        </table>
                    </div>
                </header>
                <table className={styles.individualTable}>
                    <thead>
                        <th>Individual</th>
                        <th>State</th>
                        <th>Variants</th>
                    </thead>
                    <tbody>
                  
                    {data?.Status.map((item, index) => (
                            <tr key={index}>
                                <td>{roleIndividual(item.RolePGDTest)}</td>
                                <td>{StatusIndividuals(item.StatusIndividual, item.RolePGDTest)}</td>
                                <td>{item.Mutation}</td>
                            </tr>
                        ))}
                    </tbody>

                </table>

                <div key={"leyend"} className={styles.leyendDiv}>
                    <div className={styles.leyend}><div className={styles.boxColor1}></div>Non-carrier allele</div>
                    <div className={styles.leyend}><div className={styles.boxColor2}></div>Carrier allele</div>
                    <div className={styles.leyend}><div className={styles.boxColor3}></div>Likely recombinant</div>
                </div>
                <div className={styles.divGen}>
                {
                   reorderIndividuals(data?.Status).map((indi) => (
                        <div className={styles.tableGen}>
                            <div className={styles.columnGen}>
                                <div className={styles.headerGen}>{roleIndividual(indi.RolePGDTest)}</div>
                                <div className={styles.rowGen}>
                                    <div className={styles.genAfected} style={{backgroundColor: colorP(indi, indi.StatusIndividual,1)}}>P1</div>
                                <div className={styles.genAfected} style={{backgroundColor: colorP(indi, indi.StatusIndividual,2)}}>P2</div>
                                </div>
                                <div className={styles.rowGen}>
                                    <div className={
                                        (indi.RolePGDTest === 3 || indi.RolePGDTest === 1)? styles.femaleA1 :
                                            (indi.RolePGDTest === 2)? styles.maleA1 : 
                                                (indi.RolePGDTest === 0 || indi.RolePGDTest === 9 )? styles.femaleA2 :
                                                (indi.RolePGDTest === 4 )? styles.femaleA1 :
                                                (indi.RolePGDTest === 5)? styles.maleA1 :styles.maleA2


                                    }></div>
                                    <div className={
                                      (isFamiliDirect(indi.RolePGDTest))? (
                                         (indi.RolePGDTest === 3)? styles.maleA1 : 
                                            (indi.RolePGDTest === 2)? styles.maleA2 : styles.femaleA2
                                        ) : 
                                        styles.greyA}></div>
                                </div>
                                <div className={styles.label}>{StatusIndividuals(indi.StatusIndividual, indi.RolePGDTest)}</div>
                            </div>
                        </div>
                    ))
                }
                </div>
    
    
                <div>
                    <h2 className={styles.titleP}>Methodology</h2>
                    <p>
                        The informativity study is conducted by analyzing over 200 Single Nucleotide Polymorphisms (SNPs) 
                        located 2 Mb upstream and downstream of the gene or region of interest, covering a total of 4 Mb.
                        Bioinformatics tools are employed to select SNPs with the highest probability of being informative 
                        in the studied populations. These SNPs are used to establish the haplotypes of the samples, thereby
                        determining if the available information is optimal to proceed with the embryo study. Additionally,
                        full sequencing of the target gene is incorporated to facilitate direct analysis of the variants 
                        under study.
                    </p>
                    <p>

                    The DNA samples are employed to prepare Enzymatic Fragmentation and Targeted Enrichment Hybridization 
                    libraries using the PG-Seq <sup>TM</sup> Core Panel kit (Revvity). These libraries undergo sequencing 
                    on the Illumina or Element Biosciences sequencing platforms.

                    </p>
                    <p>
                        The interpretation provided in this report serves as a guideline. Decisions made following the issuance 
                        of these results are at the discretion of the clinic, including advice on the need for genetic counseling 
                        or additional diagnostic tests. Any test should be interpreted in the context of all available clinical 
                        findings. 
                    </p>
                    <p>
                        The analysis of results and report generation have been carried out using Journey Genomics 
                        software. Accuracy of the results is based on the assumption that samples received were correctly 
                        identified, family relationships are true, and the clinical diagnosis of relatives is correct.   </p>
                </div>
                <br /><br /><br /><br /> <br /><br />
                <header>
                <img src={`data:${header?.mimeType};base64,${header?.data}`} alt=""  style={{width: '100%', height: '234px'}} />

                    <div style={{marginBottom: 10}}>
                        <table className={styles.dataTable}>
                            <tr >
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.Name}</td>
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.NamePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.Birthdate)}</td>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.BirthdatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientId}</td>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientIdPartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.Gender) === 1 ? "male" : "female"}</td>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.GenderPartner) === 1 ? "male" : "female"}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleType}</td>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleTypePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDate)}</td>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDatePartner)}</td>
                            </tr>
                            <tr>
                               <td className={styles.reportDate} colSpan={4}><b>Report date:</b> {formatDate(data?.ReportDate)}</td>
                            </tr> 
                
                        </table>
                    </div>
                </header>
                <div>
                    <h2 className={styles.titleP}>PGT-M study limitations</h2>
                    <ul className={styles.list}>
                        <li> <p> <span className="dash">- </span>
                            A prior informativity study has been conducted for this test, which has been classified as SUITABLE.
                             Every PGT-M study comprises two parallel studies: a direct study (which may be optional, depending on the
                            variant to be analyzed) and an indirect study, which is indispensable and is initiated in the informativity study.</p>
                        </li>
                        <li> <p> <span className="dash">- </span>
                            This test is designed exclusively to detect the variants indicated by the clinic or patients. 
                            No other variants or diseases not previously indicated are analyzed.</p>
                        </li>
                        <li>  <p><span className="dash">- </span>
                            The embryonic status (defined as carrier, affected, or non-carrier) refers exclusively to the 
                            disease described in the Indication section, always based on the information provided by the clinic 
                            or patients regarding the presence or absence of the alteration(s) in each of the family members participating in the study.</p>
                        </li>
                        <li> <p> <span className="dash">- </span>
                            This test represents only a small part of the embryo and may not necessarily represent the content of the entire embryo.</p>
                        </li>
                        <li> <p> <span className="dash">- </span>
                            The PGT-M study is subject to artifacts that may lead to a misclassification of the embryo's status. 
                            These artifacts mainly include mosaicism and allele drop-out; the presence of maternal or external contamination cannot 
                            be completely ruled out. The entire PGT-M study is designed to minimize the possibility of diagnostic error due to these 
                            factors, and their presence can be detected at various points in the process. These artifacts are defined as follows:</p>
                            <ul>
                                <li>
                                <p>Mosaicism: A mosaic embryo is one that has two or more cell lines with different genetic compositions. 
                                    In the case of a specific disease, a mosaic embryo would have genetic material from both alleles inherited 
                                    from the affected parent.</p>
                                </li>
                                <li>
                                <p>Allele drop-out: During the laboratory process, since it is not possible to specifically guide the chemical 
                                    reactions in each sample, one allele of the embryo may be preferentially represented over the other. 
                                    In this way, only one of the alleles present in the sample would be shown, while the other would remain hidden. 
                                    If this occurs with the allele carrying the alteration, the embryo could appear non-carrier while actually being 
                                    a carrier. This is the main reason why a direct study alone is not recommended in PGT-M techniques, and an 
                                    additional indirect study is performed.</p>
                                </li>
                            </ul>
                        </li>
                        <li> <p><span className="dash">- </span>
                            The sensitivity and specificity of the technique are high. The error rate has been minimized through the application 
                            of various control points throughout the process. However, according to scientific publications, there is an approximate 7% 
                            probability of diagnostic error in the global PGT-M analysis. Therefore, since no technique is infallible, it is recommended 
                            to confirm the results in case of pregnancy.</p>
                        </li>
                    </ul>
                    <p>The percentages regarding the inheritance or transmission of traits or diseases are purely theoretical and involve numerous processes 
                    beyond our control. Hence, the final number of carrier, healthy, or affected embryos may not match expectations, considering these 
                    inheritance rules.</p>
                </div>
                <br /><br /><br /><br /> <br /><br /><br/><br/>
                <header>
                <img src={`data:${header?.mimeType};base64,${header?.data}`} alt=""  style={{width: '100%', height: '234px'}} />

                    <div style={{marginBottom: 10}}>
                        <table className={styles.dataTable}>
                            <tr >
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.Name}</td>
                                <td className={styles.name}><b>Name:</b></td>
                                <td className={styles.name}>{data?.NamePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.Birthdate)}</td>
                                <td className={styles.dataTabletd}><b>Birth date:</b></td>
                                <td className={styles.dataTabletd}>{formatDate(data?.BirthdatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientId}</td>
                                <td className={styles.dataTabletd}><b>CHN/DNI:</b></td>
                                <td className={styles.dataTabletd} >{data?.PatientIdPartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.Gender) === 1 ? "male" : "female"}</td>
                                <td className={styles.dataTabletd}><b>Sex:</b></td>
                                <td className={styles.dataTabletd} >{Number(data?.GenderPartner) === 1 ? "male" : "female"}</td>
                            </tr>
                            <tr>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleType}</td>
                                <td className={styles.dataTabletd}><b>Sample type:</b></td>
                                <td className={styles.dataTabletd} >{data?.SampleTypePartner}</td>
                            </tr>
                            <tr>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDate)}</td>
                                <td className={styles.datatdLast}><b>Sample arrival date:</b></td>
                                <td className={styles.datatdLast} >{formatDate(data?.SampleDatePartner)}</td>
                            </tr>
                            <tr>
                                <td className={styles.reportDate} colSpan={4}><b>Report date:</b> {formatDate(data?.ReportDate)}</td>
                            </tr> 
                
                        </table>
                    </div>
                </header>
                <div>
                    <h2 className={styles.titleP}>References</h2>
                        {/* FIND a la espera de las referencias */}
                        {/* <p className={styles.titleP}>Guías de la ESHRE y carpeta DGP &gt; 25. Informes genéticos &gt;  1. Informes de la competencia &gt; meter las referencias que meta la competencia.</p> */}
    
                </div>
                <div style={{display: 'flex', flexDirection:"column", alignItems: "end"}}>
                    <img src={`data:${signature?.mimeType};base64,${signature?.data}`} alt=""  />
                    <div style={{display: 'flex', flexDirection:"column", alignItems: "start"}}>
                        
                    <div>Signed by: {props.signedBy}</div>
                    <div>{props.roleSigne}</div>
                    </div>
                    </div>

               
        </div>
    </div>
    
)
    }

    const generatePgtPdf = () => {

        return (
            <div style={{textAlign: 'left'}}>
            <div style={{width: '100%', fontSize: '1.6em', padding: '0 50px 0 50px '}}  id="pdf-content">
            {/* <div style={{width: '100%', fontSize: '1.6em', padding: '0 50px 0 50px' , position: 'absolute', left: '-9999px'}}  id="pdf-content"> */}
             {generateHeader()}
    
                    <h1 className={styles.titleP} style={{textAlign: 'center'}}>PGT-M study for <i>{data?.KeySnp}</i> </h1>
                    <h2 className={styles.titleP} style={{textAlign: 'center'}}><i>{data?.Region}</i></h2>

                    <div className="">
                        <div className="">
                            <h2 className={styles.titleP}>Indication</h2>
                            <p>PGT-M (Preimplantation Genetic Testing for Monogenic Diseases) study from an embryo 
                            biopsy obtained during an IVF cycle. This study is indicated after obtaining a conclusive 
                            result from an informativity study performed in family members.</p>
                        </div>
                        <div className="">
                            <h2 className={styles.titleP}>Results</h2>
                           <p> After the analysis of {data?.TotalSNP} polymorphisms, {data?.TotalAnalyzedSNPINFO + " "} 
                            informative polymorphisms were detected which will allow to analyze the embryos successfully (Table 1).</p>
                        </div>
                    </div>
                    <div >
                        <div className={styles.titleP}>Table 1. Results obtained from PGT-M study with PG-SEQ kit.</div>
                        <div className={styles.embryoContainer}>
                        <table className={styles.patientTable}>
                            <thead >
                                <th className={styles.titleTable} >Embryo ID</th>
                                <th className={styles.titleTable} >Embryo Status</th>
                            </thead>
                           <tbody>
                            {data?.Embryos
                                .sort((a, b) => a.Name.localeCompare(b.Name))
                                .map((item, index) => (
                                  <tr key={index}>
                                        <td>{item.Name}</td>
                                        <td>{statusEmbryo(item.FinalStatus, item.Sex, embryo.find(e=> e.name === item.Name))}</td>
                                  </tr>
                             ))}
                           </tbody>
                           
                        </table>
                    </div>
                    </div>
                    
                    { data?.Embryos.length === 8 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /> <br /><br />
                            { generateHeader()} 
                        </div>
                    )}

{ data?.Embryos.length === 7 && (
                        <div>
                            <br /><br /><br /><br /><br /><br /><br /> <br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )} 
                    <table className={styles.individualTable}>
                        <thead>
                            <th>Sample Name</th>
                            <th>State</th>
                            {props.seeSex && <th>Sex</th>}
                        </thead>
                        <tbody>
                      
                        {data?.Embryos
                            .sort((a, b) => a.Name.localeCompare(b.Name))
                            .map((item, index) => (
                                <tr key={index}>
                                    <td>{item.Name}</td>
                                    <td>{ statusEmbryo(item.FinalStatus, item.Sex, embryo.find(e=>e.name === item.Name))}</td>
                                    {props.seeSex &&<td>{item.Sex}</td>}
                                </tr>
                            ))}
                        </tbody>
    
                    </table>
                            
                    { data?.Embryos.length === 1 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                             { data?.Embryos.length === 2 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /> <br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                    { data?.Embryos.length === 3 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /> <br /><br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                     { data?.Embryos.length === 4 && (
                        <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br/>
                            { generateHeader()} 
                        </div>
                    )}
                     { data?.Embryos.length === 5 && (
                        <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /> 
                            { generateHeader()} 
                        </div>
                    )}
                    { data?.Embryos.length === 6 && (
                        <div>
                            <br /><br /><br /><br /><br/>
                            { generateHeader()} 
                        </div>
                    )}

                    
                 
<div key={"leyend"} className={styles.leyendDiv}>
                    <div className={styles.leyend}><div className={styles.boxColor1}></div>Non-carrier allele</div>
                    <div className={styles.leyend}><div className={styles.boxColor2}></div>Carrier allele</div>
                    <div className={styles.leyend}><div className={styles.boxColor3}></div>Likely recombinant</div>
                </div>
                    <h2 style={{ color: 'rgba(125,191,220,1)'}}>Family Members</h2>
                    <div className={styles.divGen}>
                    {
                        reorderIndividuals(data?.Status).map((indi) => (
                            <div className={styles.tableGen}>
                                <div className={styles.columnGen}>
                                    <div className={styles.headerGen}>{roleIndividual(indi.RolePGDTest)}</div>
                                    <div className={styles.rowGen}>
                                    <div className={styles.genAfected} style={{backgroundColor: colorP(indi,indi.StatusIndividual,1)}}>P1</div>
                                    <div className={styles.genAfected} style={{backgroundColor: colorP(indi,indi.StatusIndividual,2)}}>P2</div>
                                    </div>
                                    <div className={styles.rowGen}>
                                        <div className={
                                            (indi.RolePGDTest === 3 || indi.RolePGDTest === 1)? styles.femaleA1 :
                                                (indi.RolePGDTest === 2)? styles.maleA1 : 
                                                    (indi.RolePGDTest === 0 || indi.RolePGDTest === 9 )? styles.femaleA2 :
                                                    (indi.RolePGDTest === 4 )? styles.femaleA1 :
                                                    (indi.RolePGDTest === 5)? styles.maleA1 :styles.maleA2
    
    
                                        }></div>
                                        <div className={
                                          (isFamiliDirect(indi.RolePGDTest))? (
                                             (indi.RolePGDTest === 3)? styles.maleA1 : 
                                                (indi.RolePGDTest === 2)? styles.maleA2 : styles.femaleA2
                                            ) : 
                                            styles.greyA}></div>
                                    </div>
                                     <div className={styles.label}>{StatusIndividuals(indi.StatusIndividual, indi.RolePGDTest)}</div>
                                </div>
                            </div>
                        ))
                    }
                    </div>


                    <h2 style={{ color: 'rgba(125,191,220,1)'}}>Embryos</h2>
                    <div className={styles.divGen}>
                    {
                        data?.Embryos
                            .sort((a, b) => a.Name.localeCompare(b.Name))
                            .map((indi) => (
                            <div className={styles.tableGen}>
                                <div className={styles.columnGen}>
                                    <div className={styles.headerGen}>{cutName(indi.Name)}</div>
                                    <div className={styles.rowGen}>
                                        <div className={styles.genAfected} style={{backgroundColor: colorPEmbryo(indi,1)}}>{isLR(indi,1)}</div>
                                        <div className={styles.genAfected} style={{backgroundColor: colorPEmbryo(indi,2)}}>{isLR(indi,2)}</div>
                                    </div>
                                    <div className={styles.rowGen}>
                                        <div className={styles.embriocor}>
                                            <div className={styles.halfColoer} style={{backgroundColor: halfColor1(indi.ColorA1, 0)}}></div>
                                            <div className={styles.halfColoer} style={{backgroundColor: halfColor1(indi.ColorA1, 1)}}></div>
                                        </div>
                                        <div  className={styles.embriocor}>
                                            <div className={styles.halfColoer}style={{backgroundColor: halfColor1(indi.ColorA2, 0)}}></div>
                                            <div className={styles.halfColoer}style={{backgroundColor: halfColor1(indi.ColorA2, 1)}}></div>
                                        </div>
                                    </div>
                                    <div className={styles.label}>{statusEmbryo(indi.FinalStatus, indi.Sex,  embryo?.find(e=>e?.name === indi?.Name)) === "Likely Recombinant"? "LR" : statusEmbryo(indi.FinalStatus, indi.Sex, embryo.find(e => e.name === indi.Name))}</div>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                      
              
                    { data?.Embryos.length === 8 && (
                         <div>
                            <br /><br /> <br /><br /> <br />
                            { generateHeader()} 
                        </div>
                    )}

{ data?.Embryos.length === 7 && (
                        <div>
                            <br /><br /><br /><br /><br /><br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}
       
                    <div>
                        <h2 className={styles.titleP}>Methodology</h2>
                        <p>
                            The test is performed from a DNA sample isolated from an embryo biopsy. 
                            The DNA was amplified and after that the PGT-M study was performed using the 
                            Illumina or Element Biosciencies sequencing platforms by Next Generation Sequencing.
                        </p>
                        { data?.Embryos.length === 1 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br />
                            { generateHeader()} 
                        </div>
                    )}

                        { data?.Embryos.length === 2 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                        { data?.Embryos.length === 3 && (
                            <div>
                                <br /><br /><br /><br /><br /><br /> <br /><br /><br /> 
                                { generateHeader()} 
                            </div>
                        )}

                        { data?.Embryos.length === 4 && (
                            <div>
                                <br /><br /><br /><br /><br /><br /> <br /><br /><br />
                                { generateHeader()} 
                            </div>
                        )}
                        { data?.Embryos.length === 5 && (
                        <div>
                             <br /><br /><br /><br /><br /><br /> <br /><br /><br /> 
                            { generateHeader()} 
                        </div>
                    )}
                     { data?.Embryos.length === 6 && (
                        <div>
                             <br /><br /><br /><br /><br /><br /><br /><br /><br />
                            { generateHeader()} 
                        </div>
                    )}


                        <p>
                            Previously to the PGT-M study, the polymorphisms surrounding the mutation(s) present in the family 
                            line are analyzed to obtain linkage information between these polymorphisms and the mutation of interest (informativity study). 
                            This information is subsequently used to determine the possible carrier, non-carrier or affected status of each embryo in an 
                            indirect manner. A direct study can be also performed additionally depending on the nature of the alteration and only if it is 
                            possible.
                        </p>
                        <p>
                            The interpretation provided in this report serves as guidance; the timing of embryo transfer is at the discretion of the clinic, 
                            including advice on the need for genetic counseling or diagnostic tests. Any test results should be interpreted in the context 
                            of all available clinical findings. The analysis of the results, including the determination of each embryo status, and report 
                            eneration have been carried out using
                        </p>
                        <p>
                            Journey Genomics software. Accuracy of the results is based on the assumption that samples received 
                            were correctly identified, family relationships are true, and the clinical diagnosis of relatives is correct.
                        </p>
                    </div>


                    <div>
                        <h2 className={styles.titleP}>PGT-M study limitations</h2>
                        <ul className={styles.list}>
                            <li> <p> <span className="dash">- </span>
                                A prior informativity study has been conducted for this test, which has been classified as 
                                SUITABLE. Every PGT-M study comprises two parallel studies: a direct study (which may be 
                                optional, depending on the variant to be analyzed) and an indirect study, which is 
                                indispensable and is initiated in the informativity study.</p>
                            </li>
                            <li>  <p><span className="dash">- </span>
                                This test is designed exclusively to detect the variants indicated by the clinic or patients. No other variants or diseases not previously indicated are analyzed</p>
                            </li>
                            <li>  <p><span className="dash">- </span>
                                The embryonic status (defined as carrier, affected, or non-carrier) refers exclusively 
                                to the disease described in the Indication section, always based on the information provided 
                                y the clinic or patients regarding the presence or absence of the alteration(s) in each of the 
                                family members participating in the study.</p>
                            </li>
                            { data?.Embryos.length === 7 && (
                                        <div>
                                            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                                            { generateHeader()} 
                                        </div>
                                    )}
                            { data?.Embryos.length === 8 && (
                                    <div>
                                        <br /><br /> <br /><br /> <br /><br /><br /><br /><br />
                                        { generateHeader()}
                                        <br /> 
                                    </div>
                                )}
                            <li> <p> <span className="dash">- </span>
                                This test represents only a small part of the embryo and may not necessarily represent the content of the entire embryo.</p>
                            </li>
              
       
                            <li>  <p><span className="dash">- </span>
                                The PGT-M study is subject to artifacts that may lead to a misclassification of the embryo's status. These artifacts 
                                mainly include mosaicism and allele drop-out; the presence of maternal or external contamination cannot be completely ruled out. 
                                The entire PGT-M study is designed to minimize the possibility of diagnostic error due to these factors, and their presence can be 
                                detected at various points in the process. These artifacts are defined as follows:</p>

                                <ul>
                                    <li>
                                    <p> Mosaicism: A mosaic embryo is one that has two or more cell lines with different genetic compositions. 
                                        In the case of a specific disease, a mosaic embryo would have genetic material from both alleles inherited 
                                        from the affected parent.</p>
                                    </li>
                    { data?.Embryos.length === 1 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                    { data?.Embryos.length === 2 && (
                         <div>
                            <br /><br /><br /><br /><br /><br /> <br /><br />
                            { generateHeader()} 
                        </div>
                    )}
                                    { data?.Embryos.length === 3 && (
                                        <div>
                                            <br /><br /><br /><br /><br />
                                            { generateHeader()} 
                                        </div>
                                    )}

                                    { data?.Embryos.length === 4 && (
                                        <div>
                                            <br /><br /><br /><br /><br /><br /> <br />
                                            { generateHeader()} 
                                        </div>
                                    )}

                                    { data?.Embryos.length === 5 && (
                                        <div>
                                            <br /><br /><br /><br /><br /><br /> 
                                            { generateHeader()} 
                                        </div>
                                    )}
                                    { data?.Embryos.length === 6 && (
                                        <div>
                                            <br /><br /><br /><br /><br /><br /> <br />
                                            { generateHeader()} 
                                        </div>
                                    )}


                                    <li>
                                    <p> Allele drop-out: During the laboratory process, since it is not possible to specifically guide 
                                        the chemical reactions in each sample, one allele of the embryo may be preferentially represented over the 
                                        other. In this way, only one of the alleles present in the sample would be shown, while the other would remain hidden. 
                                        If this occurs with the allele carrying the alteration, the embryo could appear non-carrier while actually being a 
                                        carrier. This is the main reason why a direct study alone is not recommended in PGT-M techniques, and an additional 
                                        indirect study is performed.</p>
                                    </li>
                                </ul>
                            </li>
                            <li> <p> <span className="dash">- </span>
                            The sensitivity and specificity of the technique are high. The error rate has been minimized through the application of 
                            various control points throughout the process. However, according to scientific publications, there is an approximate 7% 
                            probability of diagnostic error in the global PGT-M analysis 
                            (PMC4350594). Therefore, since no technique is infallible, it is recommended to confirm the results in case of pregnancy.</p>
                            </li>
                            <li>
                            <p>The percentages regarding the inheritance or transmission of traits or diseases are purely theoretical and involve 
                                numerous processes beyond our control. Hence, the final number of carrier, healthy, or affected embryos may not match 
                                expectations, considering these inheritance rules.</p>
                            </li>
                        </ul>
                    </div>


                    <div>
                        <h2 className={styles.titleP}>References</h2>
    {/* FIND a la espera de las referencias */}
                        {/* <p className={styles.titleP}>Guías de la ESHRE y carpeta DGP &gt; 25. Informes genéticos &gt;  1. Informes de la competencia &gt; meter las referencias que meta la competencia.</p> */}
    
                    </div>
                    <div style={{display: 'flex', flexDirection:"column", alignItems: "end"}}>
                    <img src={`data:${signature?.mimeType};base64,${signature?.data}`} alt=""  />
                    <div style={{display: 'flex', flexDirection:"column", alignItems: "start"}}>
                        
                    <div>Signed by: {props.signedBy}</div>
                    <div>{props.roleSigne}</div>
                    </div>
                    </div>
    
                   
            </div>
        </div>
        
    )
    }


    

    const downloadPDF = () => {
        const input = document.getElementById('pdf-content');
    
        if (input) {
            html2canvas(input).then((canvas) => {
                const pdf = new jsPDF();
                const imgData = canvas.toDataURL('image/png');
                const imgWidth = 190; // ancho de la imagen
                const pageHeight = pdf.internal.pageSize.height;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                let heightLeft = imgHeight;
    
                let position = 0;
    
                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
    
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
    
                pdf.save('result.pdf');
            });
        }
    };

  
    const technicalInformativity = () => {
        const confidenceLevelMother = individuals.find(f => f.individual === Individuals.FEMALE)
        const confidenceLevelFather = individuals.find(f => f.individual === Individuals.MALE)

        return(
        <div style={{textAlign: 'center', width: "100%"}}>
        <div style={{width: '1080px', fontSize: '1.6em', padding: '20px 50px 0 50px '}}  id="pdf-content">
            <h1 className={styles.titleP} style={{textAlign:"left"}}>
                Informativity results
            </h1>
            <TableContainer >
                <Table style={{width: "100%"}}>
                    <Head
                       fields={fields}
                        styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                    />
                    <Body  fields={fields} items={[]} rowKeyField={""} />
                        {individuals.map((individual, i) => (
                        <TableRow >
                            <TableCell key={`individualName${i}`} >{individual.sampleName}</TableCell>

                            <TableCell key={`status${i}`}  >
                                {statusTitle()[individual.status]}
                            </TableCell>
                            <TableCell key={`variant${i}`} >{individual.mutation}</TableCell>
                            <TableCell key={`nonCall${i}`}>
                            {Math.round(individual.nonCallRate * 100) / 100} %
                            </TableCell>
                             {fields.slice(2)
                                .filter(f => f.name === 'directVariant').map((field, index) => {
                                    const direcStatus = directTesting.filter(dt=> dt.individualID === individual.id)[index]?.directTesting

                                    return <TableCell key={index}>
                                           {directTestingStatusTitle()[direcStatus]}
                                        </TableCell>
                                    
                                })}
                        </TableRow>
                        ))}

                        </Table>
                    </TableContainer>


                    <div style={{marginTop: "50px", withd: "80%"}} >
                    <TableContainer >
                    <Table style={{ withd: "80%"}}>
                        <TableRow>
                            <TableCell/>
                            <TableCell  style={{ textAlign: "center",fontWeight: "bold"}}>
                                {t('maternalInherit')} 
                            </TableCell>
                            <TableCell style={{ textAlign: "center",fontWeight: "bold"}}>
                                {t('paternalInherit')} 
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><div style={{width: "200px", overflowWrap: "break-word", textAlign: "center", fontWeight: "bold"}}>{t('aboveGenResult')}</div></TableCell>
                            <TableCell style={{textAlign: "center"}}>{confidenceLevelMother?.upInfo}</TableCell>
                            <TableCell style={{textAlign: "center"}}>{confidenceLevelFather?.upInfo}</TableCell>
                        </TableRow>
                        {(maternalVar.length + paternalVar.length)=== 0 && (
                            <TableRow>
                              <TableCell><div style={{width: "200px", overflowWrap: "break-word", textAlign: "center", fontWeight: "bold"}}>{t('inGenResult')}</div></TableCell>
                              <TableCell style={{textAlign: "center"}}>{confidenceLevelMother?.inInfo}</TableCell>
                              <TableCell style={{textAlign: "center"}}>{confidenceLevelFather?.inInfo}</TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                            <TableCell><div style={{width: "200px", overflowWrap: "break-word", textAlign: "center", fontWeight: "bold"}}>{t('BelowGenResult')}</div></TableCell>
                            <TableCell style={{textAlign: "center"}}>{confidenceLevelMother?.downInfo}</TableCell>
                            <TableCell style={{textAlign: "center"}}>{confidenceLevelFather?.downInfo}</TableCell>
                        </TableRow>
                        <TableRow>
                        {maternalVar?.length > 0 &&paternalVar?.length>0 && <TableCell style={{paddingLeft: "55px", fontWeight: "bold"}}>{t('confidenceLevel')}</TableCell>}
                                <TableCell style={{textAlign: "center"}}>
                            {maternalVar?.length > 0 &&(
                                <div  style={{backgroundColor: confidenceColor(confidenceLevelMother?.confidenceLevel), borderRadius: "5px" }}>
                                    {confidenceLevelMother?.confidenceLevel}
                                </div>
                                )}
                            </TableCell>
                             <TableCell style={{textAlign: "center"}}>
                           {paternalVar?.length>0 &&(
                                <div  style={{backgroundColor: confidenceColor(confidenceLevelFather?.confidenceLevel), borderRadius: "5px" }}>
                                    {confidenceLevelFather?.confidenceLevel}
                                </div>
                                )}
                            </TableCell>
                        </TableRow>

                    </Table>
                </TableContainer>                              
            </div>
        </div>
        </div>
        )
    }
    
    function handleHerenci(alele: number, embFinalEstatus: FinalStatus, embrio: EmbryoModel): string{
        if (alele === 1){
            if (embrio.a1ColumnName !== 'P1') {
                    if (embrio.a1ColumnName === 'LRCM') return "Recombinant but seems to be Carrier from Mother"
                    if (embrio.a1ColumnName === 'LRNC') return "Recombinant but seems to be Non-Carrier"
            }
            return (embrio.finalStatus === FinalStatus.Affected || embFinalEstatus === FinalStatus.CarrierFromMother)
                ? t("Maternal Carrier")
                : t("Non Carrier")
        } else {
            if (embrio.a2ColumnName !== 'P1') {
                    if (embrio.a2ColumnName === 'LRCF') return "Recombinant but seems to be Carrier from Father"
                    if (embrio.a2ColumnName === 'LRNC') return "Recombinant but seems to be Non-Carrier"
            }
            return (embrio.finalStatus === FinalStatus.Affected || embFinalEstatus === FinalStatus.CarrierFromFather)
                ? t("Paternal Carrier")
                :t("Non Carrier")
        }
    }


    const technicalPGTM = () => {
        return(
        <div style={{textAlign: 'center', width: "100%"}}>
        <div style={{width: '100%', fontSize: '1.6em', padding: '20px 50px 0 50px '}}  id="pdf-content">
            <h1 className={styles.titleP} style={{textAlign:"left"}}>
               PGT-M Results
            </h1>
            <TableContainer >
                <Table style={{width: "100%"}}>
                    <Head
                       fields={fields}
                        styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                    />
                    <Body  fields={fields} items={[]} rowKeyField={""} />
                        {individuals.map((individual, i) => (
                        <TableRow >
                            <TableCell key={`individualName${i}`} >{individual.sampleName}</TableCell>

                            <TableCell key={`status${i}`}  >
                                {statusTitle()[individual.status]}
                            </TableCell>
                            <TableCell key={`variant${i}`} >{individual.mutation}</TableCell>
                            <TableCell key={`nonCall${i}`}>
                            {Math.round(individual.nonCallRate * 100) / 100} %
                            </TableCell>
                             {fields.slice(2)
                                .filter(f => f.name === 'directVariant').map((field, index) => {
                                    const direcStatus = directTesting.filter(dt=> dt.individualID === individual.id)[index]?.directTesting

                                    return <TableCell key={index}>
                                           {directTestingStatusTitle()[direcStatus]}
                                        </TableCell>
                                    
                                })}
                        </TableRow>
                        ))}

                        </Table>
                    </TableContainer>


                    <TableContainer style={{marginTop: "50px"}}>
                    <Table>
                    <Head
                       fields={fields2}
                        styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                    />
                    <Body fields={fields2} items={[]} rowKeyField={''} />
                        {embryo.map(emb =>(
                            <TableRow>
                                <TableCell>{emb.name}</TableCell>
                                <TableCell> {Math.round(emb.nonCallRate * 100) / 100} %</TableCell>
                                {fields2.slice(2)
                                .filter(f => f.name === 'directVariant').map((field, index) => {
                                    const direcStatus = directTesting.filter(dt=> dt.individualID === emb.id)[index]?.directTesting
                                    return  (
                                        <TableCell key={index}>
                                           {directTestingStatusTitle()[direcStatus]}
                                        </TableCell>
                                    );
                                })}
                                <TableCell>{handleHerenci(1,emb.finalStatus, emb)}</TableCell>
                                <TableCell>{handleHerenci(2,emb.finalStatus, emb)}</TableCell>
                               {props.seeSex && <TableCell>{emb.embryoGender}</TableCell>}
                                <TableCell>{statusEmbryo(emb.finalStatus, emb.embryoGender, emb)}</TableCell>
                                {/* <TableCell></TableCell> */}
                            </TableRow>
                        ))}
                    </Table>
                </TableContainer>
                                    
        </div>
        </div>
        )
    }

        const infoToSee = () => {
        if (technicalSheet){
            if (props.fromIndi || data?.Embryos == undefined) return generatePDF()
            if  (data?.Embryos != undefined || props.fromEmb) return generatePgtPdf()
        } else {
            if (props.fromIndi || data?.Embryos == undefined) return technicalInformativity()
            if  (data?.Embryos != undefined || props.fromEmb) return technicalPGTM()}
    }

    const goBack = () => {
        if (props.fromIndi) {
            props.setFromIndi(false)
            props.setCurrentStep(1)
        } else {
            props.setFromEmb(false)
            props.setCurrentStep(2)
        }
    }


    return (
        <>
        {/* {isDataLoaded? 
    (  */}
        <div>
            <Button
                variant="contained"
                startIcon={<ArrowBack/>}
                onClick={props.decreaseStep}
                className={styles2.button}
                style={{display: 'flex', alignSelf: 'flex-start'}}>
                {t('back')}
            </Button>

            <Button
                variant="contained"
               
                onClick={downloadPDF}
                className={styles2.button}
                style={{display: 'flex', alignSelf: 'flex-start'}}>
                {t('download')}
            </Button>

            {  //((data?.Embryos !== undefined && props.project?.embryoValidateBy != "" )|| props.project?.infoValidateBy != "") && (
                <Button
                    variant="contained"
                
                    onClick={() => setTechnicalSheet(!technicalSheet)}
                    className={styles2.button}
                    style={{display: 'flex', alignSelf: 'flex-start'}}>
                    {!technicalSheet? (data?.Embryos == undefined || props.fromIndi)? t('InformativityReport'):t('PGT-MReport') : t('Technical Sheet')}
                </Button>
            }
       
         {infoToSee()}
    </div>

        </>
    )
}